(function() {
  'use strict';

  angular.module('app.previewpanel')
    .controller('PreviewPanelCtrl', PreviewPanelCtrl);

  /** @ngInject */
  function PreviewPanelCtrl($scope, maps, panels, $rootScope) {
    // let vm = this;
    $scope.otcVisible = true;
    $scope.aucVisible = true;
    // console.log('parcels ', $scope.parcels);
    $scope.$on('parcels-filtered', function(event, parcels) {
      $scope.parcels = parcels;
      $scope.previousParcels = parcels;
      $scope.filterType();
      $scope.$apply();
    });

    $scope.filterType = function() {
      if ($scope.otcVisible && $scope.aucVisible) {

      } else if ($scope.otcVisible) {
        let typeParcels = [];
        $scope.parcels.forEach(function(parcel) {
          if (parcel.attributes.ProposedSaleType !== 'Auction') {
            typeParcels.push(parcel);
          }
        });
        $scope.parcels = typeParcels;
      } else if ($scope.aucVisible) {
        let typeParcels = [];
        $scope.parcels.forEach(function(parcel) {
          if (parcel.attributes.ProposedSaleType !== 'Over the Counter') {
            typeParcels.push(parcel);
          }
        });
        $scope.parcels = typeParcels;
      } else {
        $scope.parcels = [];
      }
    };

    $scope.$on('parcels-typefiltered', function(event, saleType, layerVisible, otcVisible, aucVisible) {
      $scope.otcVisible = otcVisible;
      $scope.aucVisible = aucVisible;
      // filter results from the panels
      if (!layerVisible) {
        let typeParcels = [];
        $scope.parcels.forEach(function(parcel) {
          if (parcel.attributes.ProposedSaleType !== saleType) {
            typeParcels.push(parcel);
          }
        });
        $scope.parcels = typeParcels;
      } else {
        $scope.previousParcels.forEach(function(parcel) {
          if (parcel.attributes.ProposedSaleType === saleType) {
            $scope.parcels.push(parcel);
          }
        });
      }
      $rootScope.$broadcast('number-tracts', $scope.parcels.length);

    });

    $scope.ok = function() {
      panels.close();
    };

    $scope.zoomToParcel = function(objectid) {
      maps.zoomToFeature(objectid);
    };

  }
})();
